import React, { ReactNode, Children } from "react"
import { Box } from "@chakra-ui/react"

type Props = {
  children: ReactNode
}

const BlocksWrapper = ({ children }: Props) => {
  const hasDynamicBlocks = Children.count(children) > 0

  return (
    <Box
      borderLeftWidth={1}
      borderRightWidth={1}
      borderBottomWidth={hasDynamicBlocks ? 1 : 0}
    >{children}
    </Box>
  )
}

export default BlocksWrapper
